export const company = {
  name: "Martimma Global Services Limited",
  shortName: "Martimma",
  tagline: "Quality in every drop!",
  slogan: "Fuelling Growth. Powering Nations.",
  description: "A fully integrated multi-sector Nigerian company driving excellence across energy, construction, agriculture, and logistics.",
  founded: 2015,
  headquarters: "Lekki, Lagos",
  offices: [
    { city: "Lekki", state: "Lagos", type: "Head Office", address: "25B Adebayo Doherty Road, Lekki Phase 1" },
    { city: "Warri", state: "Delta", type: "Operations", address: "Km 4 Warri-Patani Road, Ubolo, Asubi" },
    { city: "Benin City", state: "Edo", type: "Operations", address: "Km 15 Upper Sakponba Road, Evbiakagba" }
  ],
  contact: {
    phone: "+234 800 123 5678",
    phone2: "+234 703 022 3894",
    phone3: "+234 705 544 7935",
    email: "info@martimmaglobal.com",
    email2: "martimma80@gmail.com",
    website: "www.martimmaglobal.com"
  },
  social: {
    linkedin: "https://linkedin.com/company/martimma",
    twitter: "https://twitter.com/martimma"
  },
  stats: {
    employees: "100+",
    stations: "Multiple",
    zones: "6 Geopolitical",
    localContent: "95%"
  }
}

export const navigation = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Services", href: "/services" },
  { name: "Infrastructure", href: "/infrastructure" },
  { name: "HSE & Quality", href: "/hse" },
  { name: "Contact", href: "/contact" },
]

export const services = [
  {
    id: "petroleum",
    title: "Petroleum Products",
    subtitle: "Supply & Distribution",
    description: "Powering Nigeria's economy with reliable energy solutions. We supply PMS, AGO, DPK, ATK, LPFO, lubricants, and operate retail service stations nationwide.",
    icon: "Fuel",
    color: "red",
    features: [
      "Premium Motor Spirit (PMS/Gasoline)",
      "Automotive Gas Oil (AGO/Diesel)",
      "Dual Purpose Kerosene (DPK)",
      "Aviation Turbine Kerosene (ATK)",
      "Low Pour Fuel Oil (LPFO)",
      "High-performance Lubricants",
      "Retail Service Stations",
      "C&I Bulk Supply"
    ],
    image: "/images/petroleum-hero.jpg"
  },
  {
    id: "construction",
    title: "Construction",
    subtitle: "Engineering & Build",
    description: "From civil works to specialized industrial facilities, we deliver durable infrastructure across Nigeria with end-to-end engineering capabilities.",
    icon: "HardHat",
    color: "yellow",
    features: [
      "Civil Engineering (Roads, Buildings, Bridges)",
      "Mechanical Services (HVAC, Plumbing, Piping)",
      "Electrical Services (Power, Renewables, Smart Systems)",
      "Specialized Construction (Fuel Stations, Tank Farms)",
      "Industrial Facilities",
      "Energy Infrastructure"
    ],
    image: "/images/construction-hero.jpg"
  },
  {
    id: "agriculture",
    title: "Agricultural",
    subtitle: "Farm-to-Table Solutions",
    description: "Supporting Nigeria's food security agenda with end-to-end agricultural services from inputs to post-harvest processing.",
    icon: "Wheat",
    color: "red",
    features: [
      "Farm Inputs Supply (Seeds, Fertilizers, Chemicals)",
      "Mechanization Services (Clearing, Tilling, Harvesting)",
      "Crop Production Support (Advisory, Soil Testing)",
      "Post-Harvest Services (Drying, Storage, Processing)",
      "Farm Machinery Supply",
      "Best Practices Training"
    ],
    image: "/images/agriculture-hero.jpg"
  },
  {
    id: "logistics",
    title: "Haulage & Logistics",
    subtitle: "Fleet & Transport",
    description: "Moving Nigeria's economy safely and on time with a modern GPS-tracked fleet operating across all six geopolitical zones.",
    icon: "Truck",
    color: "yellow",
    features: [
      "Petroleum Products Haulage (GPS-tracked Tankers)",
      "General Cargo Transport (Construction, Agri, Containerized)",
      "Specialized Transport (Hazmat, Oversized, Project Logistics)",
      "Fleet Management (Telematics, Maintenance, Training)",
      "DPR-compliant Operations",
      "24/7 Dispatch Center"
    ],
    image: "/images/logistics-hero.jpg"
  }
]

export const coreValues = [
  { title: "Teamwork", description: "We win together, across functions and borders", icon: "Users" },
  { title: "Excellence", description: "We raise the bar and deliver beyond expectations", icon: "Target" },
  { title: "Safety", description: "Zero-harm culture for people, assets, and environment", icon: "Shield" },
  { title: "Service", description: "Customer-first mindset in everything we do", icon: "Handshake" },
  { title: "Quality", description: "Consistent standards, every drop, every delivery", icon: "Award" },
  { title: "Trust", description: "Reliability that builds long-term partnerships", icon: "Heart" },
  { title: "Innovation", description: "Continuous improvement and smart solutions", icon: "Lightbulb" },
  { title: "Integrity", description: "We do the right thing, always", icon: "Scale" }
]

export const journey = [
  { year: "2015", title: "Incorporation", description: "Established as a petroleum products marketer under CAC (CAMA 1990)" },
  { year: "2017-2019", title: "Retail Expansion", description: "Opened multiple service stations across Lagos, Warri & Benin City" },
  { year: "2020-2022", title: "Diversification", description: "Expanded into Construction & Agricultural solutions" },
  { year: "2023-2024", title: "Logistics Scale-up", description: "Fleet expansion and Lekki Free Trade Zone terminal operations" },
  { year: "2025-2026", title: "National Footprint", description: "Integrated multi-sector operator across all 6 geopolitical zones" }
]

export const infrastructure = {
  headline: "Our Retail Network & Depot Partnerships",
  description: "Martimma operates its own filling stations across key Nigerian cities and maintains strategic partnerships with major petroleum product depots nationwide — ensuring our customers receive reliable, timely supply no matter where they are.",
  stations: [
    {
      city: "Lagos",
      state: "Lagos State",
      zone: "South-West",
      type: "Retail Service Station",
      address: "25B Adebayo Doherty Road, Lekki Phase 1",
      highlights: ["Premium Motor Spirit (PMS)", "Automotive Gas Oil (AGO)", "Lubricants", "Retail Services"],
      image: "/images/station-lagos.jpg",
    },
    {
      city: "Warri",
      state: "Delta State",
      zone: "South-South",
      type: "Operations & Retail Station",
      address: "Km 4 Warri-Patani Road, Ubolo, Asubi",
      highlights: ["PMS & AGO Supply", "Bulk & Retail Dispensing", "Industrial Customer Support", "C&I Supply"],
      image: "/images/station-warri.jpg",
    },
    {
      city: "Benin City",
      state: "Edo State",
      zone: "South-South",
      type: "Operations & Retail Station",
      address: "Km 15 Upper Sakponba Road, Evbiakagba",
      highlights: ["PMS & AGO Supply", "Haulage Staging Point", "Agricultural Sector Support", "Local Distribution"],
      image: "/images/station-benin.jpg",
    },
  ],
  depotPartners: {
    description: "To guarantee supply continuity and competitive pricing, Martimma has active offtake arrangements with licensed petroleum product depots across multiple geopolitical zones. These partnerships allow us to serve customers across Nigeria without geographic constraints.",
    zones: [
      { name: "South-West", depots: "Lagos, Sagamu, Ibadan corridor depots" },
      { name: "South-South", depots: "Warri, Port Harcourt, Calabar terminal partners" },
      { name: "South-East", depots: "Onitsha, Aba, Enugu supply points" },
      { name: "North-Central", depots: "Abuja, Lokoja, Makurdi distribution hubs" },
      { name: "North-West", depots: "Kano, Kaduna, Sokoto supply partners" },
      { name: "North-East", depots: "Maiduguri, Bauchi, Gombe reach network" },
    ]
  },
  capabilities: [
    { title: "Nationwide Filling Stations", description: "DPR-licensed retail stations in Lagos, Warri, and Benin City serving both retail and bulk industrial customers.", icon: "Fuel" },
    { title: "Multi-Depot Partnerships", description: "Active offtake agreements with depots across all six geopolitical zones, ensuring no supply gap for our customers.", icon: "Network" },
    { title: "GPS-Tracked Fleet", description: "Modern haulage fleet with real-time GPS monitoring for safe, on-time delivery of petroleum products and general cargo.", icon: "Navigation" },
    { title: "24/7 Supply Operations", description: "Round-the-clock operations at our stations and dispatch centres to meet the energy demands of industries and individuals.", icon: "Clock" },
    { title: "DPR & Regulatory Compliance", description: "All stations and operations are fully compliant with Department of Petroleum Resources (DPR) standards and NESREA regulations.", icon: "Shield" },
    { title: "Bulk & C&I Supply", description: "Dedicated bulk supply service for Commercial & Industrial customers — factories, generators, maritime, and construction sites.", icon: "Zap" },
  ]
}

export const hse = {
  title: "Zero-Harm. Always.",
  description: "Our HSE framework protects people, assets, and the environment across every operation.",
  pillars: [
    { title: "Accident & Injury Prevention", description: "Proactive identification and elimination of workplace hazards", icon: "AlertTriangle" },
    { title: "Environmental Protection", description: "Operating in harmony with NESREA standards and ecosystems", icon: "Leaf" },
    { title: "Waste Management", description: "Responsible handling, segregation and disposal of all waste streams", icon: "Recycle" },
    { title: "Risk Assessment & Control", description: "Job-hazard analysis on every task before execution", icon: "ClipboardCheck" },
    { title: "PPE Provision & Training", description: "Industry-grade equipment and continuous workforce training", icon: "Shield" },
    { title: "Safety Culture & Leadership", description: "Top-down commitment, bottom-up engagement on safety", icon: "Users" }
  ],
  certifications: [
    { name: "ISO 9001:2015", description: "Quality management system aligned", status: "Aligned" },
    { name: "DPR", description: "Department of Petroleum Resources specifications", status: "Compliant" },
    { name: "NESREA", description: "Environmental regulations fully adhered", status: "Compliant" },
    { name: "CAC / NCS / FIRS", description: "Fully incorporated and tax-compliant", status: "Registered" }
  ]
}

export const leadership = {
  team: [
    { role: "Managing Director / CEO", description: "Day-to-day leadership across all four divisions" },
    { role: "Executive Directors", description: "Sector-specific leaders for Petroleum, Construction, Agriculture & Logistics" },
    { role: "HSE & Compliance Officers", description: "Safety, quality and regulatory oversight" },
    { role: "Board of Directors", description: "Strategic governance and long-term vision setting" }
  ],
  stats: {
    experience: "10+ Years",
    workforce: "100+ Skilled",
    divisions: "4 Divisions Led"
  }
}

export const testimonials = [
  {
    quote: "Martimma's reliable fuel supply has kept our operations running smoothly for years. Their quality is unmatched.",
    author: "Industrial Client",
    role: "Manufacturing Sector"
  },
  {
    quote: "The construction team delivered our tank farm project on time and above safety standards. True professionals.",
    author: "Energy Partner",
    role: "Downstream Operations"
  },
  {
    quote: "Their agricultural inputs and mechanization services transformed our farm productivity significantly.",
    author: "Farm Cooperative",
    role: "Delta State"
  }
]
